import React from "react";
import { DotProps, Dot } from "recharts";

const ArtifactLogicDot = (props: DotProps & { adaptiveVisibility?: boolean }) => {
  // @ts-ignore
  const { cx, cy, type, strokeWidth, payload, path } = props;
  let { stroke, r, fill } = props;

  const dataItem = path ? payload[path] : payload;

  if (dataItem) {
    r = 0.5;
    if (dataItem.is_notification_logic && dataItem.notification) {
      r = 5;
      stroke = "#E3345E";
      fill = "#E3345E";
    }
  }

  return <Dot cx={cx} cy={cy} stroke={stroke} r={r} type={type} fill={fill} strokeWidth={strokeWidth} />;
};

export default ArtifactLogicDot;
